import React, { Fragment, useEffect, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import Search from "../../components/InputFields/Search";
import workflow_header from "../../assets/images/users_usermodule.svg";
import "./Users.css";
import CreateUser from "./user/CreateUser";
import UserListing from "./user/UserListing";
import RolesListing from "./roles/RolesListing";
import AddRoles from "./roles/AddRoles";
import ObjectListing from "./objects/ObjectListing";
import AddObject from "./objects/AddObject";
import UserDetails from "./user/UserDetails";
import RolesDetails from "./roles/RolesDetails";
import { platformLayout } from "../../utils/constants";
import { useSelector } from "react-redux";
import { failed } from "../../utils/Tostify";
import { useLocation } from "react-router";

const Users = ({ direction, ...args }) => {
    // let role = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.portalLayout);
    let role = localStorage.getItem("userRole");
    let roleId = localStorage.getItem("roleId");
    const roles = useSelector((state) => state?.userReducer?.user?.roles);
    const defaultPermissions = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.permissions);
    const matchedRole = roles?.find((role) => role.value._id === roleId);
    const permissions = matchedRole?.permissions || defaultPermissions;
    const isReadonly = permissions.find((obj)=> obj?.objectName === "Users")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('read');
    const isCreate =   permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('create');
    const isEdit =   permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('edit');
    const [openAddOrg, setOpenAddOrg] = useState(false);
    const location = useLocation();
    const [CurrentTab, setCurrentTab] = useState(location.state?.tab || "userListing");
    const [userData, setUserData] = useState({});
    const [roleData, setRoleData] = useState({});
    const [search, setSearch] = useState("");

    const renderView = () => {
        switch (CurrentTab) {
            case "userListing":
                return <UserListing setCurrentTab={setCurrentTab} userData={(data)=> setUserData(data)} searchKey={search}/>;
            case "createUser":
                return <CreateUser setCurrentTab={setCurrentTab}/>;
            case "userDetails":
                return <UserDetails userDetails={userData} setCurrentTab={setCurrentTab} roleData={(data)=> setRoleData(data)}/>;
            case "rolesListing":
                return <RolesListing setCurrentTab={setCurrentTab} roleData={(data)=> setRoleData(data)} searchKey={search}/>;
            case "addRoles":
                return <AddRoles setCurrentTab={setCurrentTab} />;
            case "rolesDetails":
                    return <RolesDetails roleData={roleData} setCurrentTab={setCurrentTab} userData={(data)=> setUserData(data)}/>;
            case "objectListing":
                return <ObjectListing />;
            case "addObject":
                return <AddObject />;
            default:
                return null; // Or a default component if necessary
        }
    };

    const handleSearch = (e) =>{
        setSearch(e.target.value);
    };

    useEffect(()=>{
        renderView();
    },[search]);

    return (
        <Fragment>
            <div className="workflow_blocks user_blk">
                <div className="d-flex justify-content-between align-items-center main-header-block flex-wrap header-bg gap-2">
                    <div className="left_header d-flex align-items-center gap-2">
                        <img src={workflow_header} />
                        <h2 className="home-title">Users</h2>
                    </div>
                    <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap">
                        <div className="right_header d-flex align-items-center me-3">
                            {role == platformLayout.Platform ? <Search value={search} onChange={(e) => handleSearch(e)}/> : CurrentTab === "userListing" && <Search value={search} onChange={(e) => handleSearch(e)}/>}
                            {role == platformLayout.Platform ? <Dropdown
                                isOpen={openAddOrg}
                                toggle={() => isCreate ? setOpenAddOrg((prev)=> !prev) : isReadonly ? failed("You have only read access") : setOpenAddOrg((prev)=> !prev)}
                                direction={direction}
                            >
                                <DropdownToggle caret size="xl" className="column_blk p-0 m-0">
                                    <div className="for_details header-add-icon">
                                        <i className="fa fa-plus"></i>
                                    </div>
                                </DropdownToggle>
                                <DropdownMenu {...args}>
                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => setCurrentTab("createUser")}>
                                        <div
                                            className="add_hosp"
                                        >
                                            {" "}
                                            Create User
                                        </div>
                                    </DropdownItem>
                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => setCurrentTab("addRoles")}>
                                        <div
                                            className="add_hosp"
                                        >
                                            Create Role
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown> : null}
                        </div>
                    </div>
                </div>
                <div className={role == platformLayout.Platform ? "d-flex gap-4 tab_content_blk" : "tab_content_blk"}>
                    {role == platformLayout.Platform && <div className="tabs_button">
                        <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={() => isEdit ? (setCurrentTab("userListing"),setSearch("")) : isReadonly ? failed("You have only read access") : (setCurrentTab("userListing"),setSearch(""))} style={(CurrentTab === "createUser" || CurrentTab === "userListing" || CurrentTab === "userDetails") ? { color: "white", backgroundColor: "#335FFC" } : null}>Users</button>
                        <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={() => isEdit ? (setCurrentTab("rolesListing"),setSearch("")) : isReadonly ? failed("You have only read access") : (setCurrentTab("rolesListing"),setSearch(""))} style={(CurrentTab === "rolesListing" || CurrentTab === "addRoles" || CurrentTab === "rolesDetails") ? { color: "white", backgroundColor: "#335FFC" } : null}>Roles</button>
                        <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={() => isEdit ? (setCurrentTab("objectListing"),setSearch("")) : isReadonly ? failed("You have only read access") : (setCurrentTab("objectListing"),setSearch(""))} style={(CurrentTab === "objectListing" || CurrentTab === "addObject") ? { color: "white", backgroundColor: "#335FFC" } : null}>Objects</button>
                    </div>}
                    <div className={role == platformLayout.Platform ? "Form_workflow_container table_listing_color" : "Form_workflow_container_Org"}>
                        {renderView()}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Users;
